import React from "react";

import { cn } from "../../utils/cn";

type ButtonLinkProps = React.ComponentProps<"a"> & {
  arrow?: boolean;
  variant?: "underline" | "solid";
};

// underline · CTA de texto, herda a cor da seção (funciona em .dark-sec sem variante)
// solid    · CTA primário emoldurado das refs estáticas (.btn-y): amarelo cta sobre
//            tinta, sombra dura só no hover. Cor fixa, não herda a seção.
const variants = {
  underline: cn(
    "min-h-11 items-center gap-2 border-b-[3px] border-current",
    "transition-[opacity,transform] duration-200 ease-out hover:opacity-70 hover:-translate-y-0.5 active:translate-y-0 active:scale-[.98] active:opacity-80"
  ),
  solid: cn(
    "items-center justify-center gap-2.5 bg-cta text-tinta px-[clamp(22px,2vw,30px)] py-[clamp(14px,1.6svh,18px)]",
    // sombra nasce do zero no hover: o deslocamento -2px faz o bloco "descolar" do fundo
    "shadow-[0_0_0_var(--color-tinta)] hover:shadow-[5px_5px_0_var(--color-tinta)]",
    "transition-[transform,box-shadow] duration-150 ease-out hover:-translate-x-0.5 hover:-translate-y-0.5",
    "active:translate-x-0 active:translate-y-0.5 active:scale-[.99] active:shadow-[0_0_0_var(--color-tinta)]"
  ),
};

export function ButtonLink({ className, arrow, variant = "underline", children, ...props }: ButtonLinkProps) {
  return (
    <a
      className={cn(
        "inline-flex cursor-pointer touch-manipulation select-none",
        "font-display uppercase tracking-[.05em] leading-none text-[1.05rem]",
        variants[variant],
        "[&_.arr]:transition-transform [&_.arr]:duration-200 hover:[&_.arr]:translate-x-1.5",
        className
      )}
      {...props}
    >
      {children}
      {arrow && (
        <span className="arr" aria-hidden="true">
          →
        </span>
      )}
    </a>
  );
}
